import { render } from "./SubPlanCard.vue?vue&type=template&id=1c1a52d0&scoped=true"
import script from "./SubPlanCard.vue?vue&type=script&lang=js"
export * from "./SubPlanCard.vue?vue&type=script&lang=js"

import "./SubPlanCard.vue?vue&type=style&index=0&id=1c1a52d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1a52d0"]])

export default __exports__